import React, { useState, useEffect } from "react";
import moment from "moment";
import { Tabs, Tab } from "react-bootstrap";
import SalesGoals from "./SalesGoals";
import clientAxios from "../../../clients/clientAxios";

export default function Birthday({ classroom = "no" }) {
  const [show, setShow] = useState(false);
  const [birthdayList, setBirthdayList] = useState<Partial<dbResponse>>({});
  const [salesKey, setSalesKey] = useState(0);

  const TAB_KEYS = {
    BIRTHDAYS: 'birthdays',
    SALES: 'sales'
  } as const;

  const handleTabSelect = (selectedTabKey: string | null) => {
    if (selectedTabKey === TAB_KEYS.SALES) {
      setSalesKey(previousKey => previousKey + 1);
    }
  };

  useEffect(() => {
    clientAxios.get(`/students/birthdays/${classroom}`)
      .then(({ data }) => {
        setBirthdayList(data);
      })
      .catch((err) => {
        console.error(
          err.response.data ? err.response.data.message : err.message
        );
      });
  }, [classroom]);

  return (
    <>
      <aside
        className="sidebar p-4 position-fixed"
        style={{
          overflowY: "scroll",
          left: show ? 0 : "-17rem",
          display: show ? "block" : "none",
          opacity: show ? 1 : 0,
        }}
      >
        <Tabs
          defaultActiveKey={TAB_KEYS.SALES}
          id="sidebar-tabs"
          className="mb-3"
          onSelect={handleTabSelect}
        >
          <Tab eventKey={TAB_KEYS.BIRTHDAYS} title="Cumpleaños 🎈">
            <h1 className="display-5">
              Cumpleaños!{" "}
              <span role="img" aria-label="ballon">
                🎈
              </span>
            </h1>
            <hr />
            {classroom ? (
              <>
                <h2>Hoy:</h2>
                {birthdayList.birthdayToday?.length !== 0 ? (
                  <ul>
                    {birthdayList.birthdayToday?.map((student, i) => (
                      <li key={i}>
                        {student.name}{" "}
                        <small className="text-muted">
                          ({moment(student.birthDate).format("L")})
                        </small>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p className="text-muted">
                    <i>Ningún alumno cumple años hoy </i>
                    <span role="img" aria-label="sad face">
                      😢
                    </span>
                  </p>
                )}

                <h2>Este mes:</h2>
                {birthdayList.birthdayNear?.length !== 0 ? (
                  <ul>
                    {birthdayList.birthdayNear?.map((student, i) => (
                      <li key={i}>
                        {student.name}{" "}
                        <small className="text-muted">
                          ({moment(student.birthDate).format("L")})
                        </small>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p className="text-muted">
                    <i>Ningún alumno cumple años hoy </i>
                    <span role="img" aria-label="sad face">
                      😢
                    </span>
                  </p>
                )}
              </>
            ) : (
              <p>Seleccione una comisión para ver los cumpleaños</p>
            )}
          </Tab>
          <Tab eventKey={TAB_KEYS.SALES} title="Objetivos 🎯">
            <SalesGoals key={salesKey} />
          </Tab>
        </Tabs>
      </aside>

      <button
        onClick={() => setShow(!show)}
        className="birthday-button position-fixed"
        style={{ left: show ? "32vw" : 0 }}
      >
        <strong> {show ? "<<" : ">>"} </strong>
      </button>
      {show ? (
        <div
          className="backdrop position-fixed"
          style={{ opacity: show ? 1 : 0 }}
          onClick={() => setShow(!show)}
        ></div>
      ) : null}
    </>
  );
}

interface birthdayType {
  name: string;
  id: string;
  birthDate: string;
}

interface dbResponse {
  birthdayToday: birthdayType[];
  birthdayNear: birthdayType[];
}
